import React from 'react';
import { ServicePoints } from '../components/service-points/ServicePoints';

export default function ServiceLocationsContainer() {
  return <ServicePoints />;
}
